import { ActivitySelect } from '@/components/ActivitySelect';
import { Button } from '@/components/Button';
import { Form } from '@/components/Form';
import { Flex } from '@/components/Grid';
import { Heading } from '@/components/Heading';
import {
  type AdActivityItemType,
  type AdCategoryItemType,
  type AdType,
} from '@/resource/ad';
import { type SetState } from '@/util/types';
import { CancelLink } from './CancelLink';

type Props = {
  adType: AdType;
  isValid: boolean;
  categories: AdCategoryItemType[];
  activities: AdActivityItemType[];
  setActivities: SetState<AdActivityItemType[]>;
  onBack: () => void;
  onNext: () => void;
};

const maxActivityCount = 4;

export function SelectActivityForm({
  adType,
  isValid,
  categories,
  activities,
  setActivities,
  onBack,
  onNext,
}: Props) {
  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        onNext();
      }}
    >
      <Flex dir="column" gap={4}>
        <Heading visualLevel={3} align="center" balance>
          Kies maximaal {maxActivityCount} activiteiten uit onderstaande lijst
        </Heading>

        <ActivitySelect
          categories={categories}
          selected={activities}
          maxSelect={maxActivityCount}
          onToggle={(activity) =>
            setActivities((list) =>
              list.some((act) => act.id === activity.id)
                ? list.filter((act) => act.id !== activity.id)
                : list.concat([activity])
            )
          }
        />

        {activities.length === 0 && (
          <p>Je hebt nog geen activiteiten gekozen.</p>
        )}
        {activities.length === 1 && <p>Je hebt 1 activiteit gekozen.</p>}
        {activities.length > 1 && (
          <p>Je hebt {activities.length} activiteiten gekozen.</p>
        )}

        <Flex justify="space-between">
          <Button
            theme="secondary"
            onClick={onBack}
            icon="chevron_left_narrow"
            iconSize={2}
          >
            Terug
          </Button>
          <Button
            type="submit"
            disabled={!isValid}
            icon="chevron_right_narrow"
            iconPosition="right"
            iconSize={2}
            onClick={onNext}
          >
            Naar foto
          </Button>
        </Flex>

        <CancelLink confirm adType={adType} />
      </Flex>
    </Form>
  );
}
